function isInstalledOnDevice(): boolean {
  // works on android and iOS
  return window.matchMedia('(display-mode: standalone)').matches;
}

function isIOsDevice() {
  const w = window as any;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !w.MSStream;
}

export function isAndroidDevice() {
  return /(android)/i.test(navigator.userAgent);
}

export function isIPhone() {
  const w = window as any;
  return /iPhone/.test(navigator.userAgent) && !w.MSStream;
}

export function isMobileDevice() {
  let check = false;
  const w = window as any;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;/* eslint-disable-line */
  })(navigator.userAgent || navigator.vendor || w.opera);

  return check;
}

export function isMobileOrTablet() {
  let check = false;
  const w = window as any;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;/* eslint-disable-line */
  })(navigator.userAgent || navigator.vendor || w.opera);
  return check;
}

export function isSafariBrowser() {
  return /^((?!chrome|android|CriOS|FxiOS).)*safari/i.test(navigator.userAgent);
}

export function getIOSVersion() {
  const match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
  return {
    major: parseInt(match![1]),
    minor: parseInt(match![2]),
    version: match![1] + '.' + match![2],
  };
}

export function isIOSVersionIsLessThan(expectedMajorVersion: number, minorVersion: number) {
  const deviceVersion = getIOSVersion();

  if (deviceVersion.major < expectedMajorVersion) {
    return true;
  }

  if (deviceVersion.major > expectedMajorVersion) {
    return false;
  }

  // equal major version, compare minor number
  return deviceVersion.minor <= minorVersion;
}

export function desktopFriendlyFlow() {
  return window.matchMedia('(min-width: 614px)').matches;
}

export function isDesktop() {
  // return !isIOsDevice() && !isAndroidDevice() && matchMedia('(min-width: 768px)').matches;

  if (isIPhone()) {
    // iphone users should always see the Mobile view
    return false;
  }

  return window.matchMedia('(min-width: 614px)').matches;
}

export function isMacOs() {
  return window.navigator.platform && window.navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}

/**
 * As There is some events that currently are being supported by iOS and Mac devices,
 * this function returns a score about how man of them are being supported in
 * the current browser
 */
export function supportsAppleSpecificEvents(): {
  supports: number;
  total: number;
} {
  let supports = 0;

  const eventNames = [
    'onwebkitmouseforcewillbegin',
    'onwebkitmouseforceup',
    'onwebkitmouseforcedown',
    'onwebkitmouseforcechanged',
    'ongesturestart',
    'ongesturechange',
    'ongestureend',
  ];

  eventNames.forEach((e: any) => {
    if (typeof window[e] !== 'undefined') {
      supports++;
    }
  });

  return {
    supports,
    total: eventNames.length,
  };
}

export function supportsTouch() {
  return isIOsDevice() || isAndroidDevice() || isMobileOrTablet();
}

export function hasWebCam(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const md = navigator.mediaDevices;
    if (!md || !md.enumerateDevices) {
      reject(false);
    }
    md.enumerateDevices().then((devices) => {
      if (devices.some((device) => 'videoinput' === device.kind)) {
        resolve(true);
      }

      reject(false);
    });
  });
}

export function closeDeviceKeyboard(): Promise<boolean> {
  if (isIOsDevice()) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const doc = document as any;
        doc.activeElement.blur();
        resolve(true);
      }, 150);
    });
  }

  return new Promise((resolve) => {
    const doc = document as any;
    doc.activeElement.blur();
    resolve(true);
  });
}

export function closeIOsDeviceKeyboard(): Promise<boolean> {
  return new Promise((resolve) => {
    if (!isIOsDevice()) {
      resolve(false);
      return;
    }
    setTimeout(() => {
      const doc = document as any;
      doc.activeElement.blur();
      resolve(true);
    }, 150);
  });
}

export function generateDeviceUid(): string {
  if (localStorage.getItem('__dp_machine_id')) {
    return localStorage.getItem('__dp_machine_id') as string;
  }
  if (crypto && typeof crypto.randomUUID === 'function') {
    const machineId = crypto.randomUUID();
    localStorage.setItem('__dp_machine_id', machineId);
    return machineId;
  }
  const timeStamp = Math.floor(Date.now()).toString();
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < 20) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    if (timeStamp.charAt(counter)) {
      result += timeStamp.charAt(counter);
    }
    counter += 1;
  }
  localStorage.setItem('__dp_machine_id', result);
  return result;
}

const getBrowserName = () => {
  const test = (regexp: RegExp) => regexp.test(window.navigator.userAgent);
  switch (true) {
    case test(/edg/i):
      return 'Microsoft Edge';
    case test(/trident/i):
      return 'Internet Explorer';
    case test(/firefox|fxios/i):
      return 'Firefox';
    case test(/opr\//i):
      return 'Opera';
    case test(/ucbrowser/i):
      return 'UC Browser';
    case test(/samsungbrowser/i):
      return 'Samsung Browser';
    case test(/chrome|chromium|crios/i):
      return 'Chrome';
    case test(/safari/i):
      return 'Safari';
    default:
      return 'Unknown';
  }
};

const getOsName = () => {
  const userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = 'Unknown';

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
};

export { isInstalledOnDevice, isIOsDevice, getBrowserName, getOsName };
